import { Box, Button, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setModalStatus } from 'redux/slices/modal.slice';
import { useCancelNutritionistAppointmentService } from 'features/appointments/services/cancel-nutritionist-appointment.service';
import { nutritionistAppointmentSelector } from 'features/appointments/selectors/nutritionist-appointments.selector';

const CancelNutritionistAppointmentWarningPanel = () => {
  const appointment = useSelector(nutritionistAppointmentSelector);

  const cancelAppointmentService = useCancelNutritionistAppointmentService();

  const dispatch = useDispatch();

  const onAcceptHandler = () => {
    cancelAppointmentService.mutate(appointment._id);
  };

  const onCancelHandler = () => {
    dispatch(
      setModalStatus({
        name: 'CANCEL_APPOINTMENT_WITH_NUTRITIONIST_WARNING',
        isActive: false,
      }),
    );
  };

  return (
    <Box>
      <Typography align="center" variant="h6">
        Cancelación consulta de tu nutriólogo
      </Typography>
      <Typography align="center">
        ¿Estás seguro que deseas cancelar tu consulta?
      </Typography>
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={onAcceptHandler}
          disabled={cancelAppointmentService.isLoading}
        >
          Si, deseo cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onCancelHandler}
          disabled={cancelAppointmentService.isLoading}
        >
          No, continuar con mi cita
        </Button>
      </Box>
    </Box>
  );
};

export default CancelNutritionistAppointmentWarningPanel;
